import { TextCodes } from '@api/types/translation/TextCodes';
import { LoadingSkeleton, Title } from '@components';
import { useAppSelector } from '@hooks';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { getSearchQuery, getTotalSearchHits } from '@store/search/search.slice';
import { colors } from '@themes/colors';
import { t } from '@translations';

// STYLES
//--------
const QueryBox = styled(Box)`
  color: ${colors.primary.mainGreen};
`;

// TYPES
//---------
export type SearchResultsTitleProps = {
  isWorking?: boolean;
};

// COMPONENT
//-----------

/**
 * Display results title.
 * Add total product count
 */
export const SearchResultsTitle = ({ isWorking }: SearchResultsTitleProps) => {
  const searchQuery = useAppSelector(getSearchQuery);
  const totalCount = useAppSelector(getTotalSearchHits)?.toString() || '';
  const title = t(TextCodes.Search.ResultsTitle, { totalCount });
  const hasQuery = Boolean(searchQuery);
  return (
    <Title variant='h3' noDot>
      {!hasQuery && t(TextCodes.Search.NoQueryTitle)}
      {hasQuery && (
        <>
          {isWorking && <LoadingSkeleton />}
          {!isWorking && (
            <>
              {title} "<QueryBox component='span'>{searchQuery}</QueryBox>"
            </>
          )}
        </>
      )}
    </Title>
  );
};
